/**
 * @generated SignedSource<<cbb30d7bf9a11511ec660d95ce68e294>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JiraAssignee_accountTagValues$data = {
  readonly jiraAssigneeAccountTagValues: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string;
      };
    }> | null | undefined;
  };
  readonly " $fragmentType": "JiraAssignee_accountTagValues";
};
export type JiraAssignee_accountTagValues$key = {
  readonly " $data"?: JiraAssignee_accountTagValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraAssignee_accountTagValues">;
};

import JiraAssigneeAccountTagValuesPaginationQuery_graphql from './JiraAssigneeAccountTagValuesPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jiraAssigneeAccountTagValues"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": JiraAssigneeAccountTagValuesPaginationQuery_graphql
    }
  },
  "name": "JiraAssignee_accountTagValues",
  "selections": [
    {
      "alias": "jiraAssigneeAccountTagValues",
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filter"
        }
      ],
      "concreteType": "AccountTagValueConnection",
      "kind": "LinkedField",
      "name": "__JiraAssignee__jiraAssigneeAccountTagValues_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountTagValueEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountTagValue",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cb9b98f3d9647fdb9203f6c1951db2d2";

export default node;
